import styled from "@emotion/styled";
import colors from "styles/colors";
import { WHITE_COLOR_NAME, BRAND_BLACK_BACKGROUND_COLOR } from "styles/color-consts";
export const StyledStickyHeader = styled.div`
  display: flex;
  flex-direction: column;

  .circle {
    width: 50px;
    height: 50px;
    border: 1px solid ${colors[BRAND_BLACK_BACKGROUND_COLOR]};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    cursor: pointer;
    background-color: ${colors[WHITE_COLOR_NAME]};
    overflow: hidden;

    .circle-text {
      opacity: 1;
      transition: opacity 0.2s ease-in-out;
      padding-left: 10px;
    }
  }

  .expanded-circle {
    animation: expandCircle 0.3s forwards;
    width: 160px;
    height: 50px;
    border-radius: 50px;
    border: 1px solid ${colors[BRAND_BLACK_BACKGROUND_COLOR]};
    background-color: ${colors[WHITE_COLOR_NAME]};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0;
    cursor: pointer;
    overflow: hidden;

    .circle-text {
      opacity: 1;
      padding-left: 10px;
      flex: 1;
    }

    img {
      margin-left: 16px;
      margin-right: 10px;
    }
  }

  .circle:not(.expanded-circle) {
    animation: collapseCircle 0.3s forwards;
  }

  @keyframes expandCircle {
    from {
      width: 50px;
    }
    to {
      width: 160px;
    }
  }

  @keyframes collapseCircle {
    from {
      width: 160px;
    }
    to {
      width: 50px;
    }
  }
`;
